import { render, staticRenderFns } from "./CrimeWhen.vue?vue&type=template&id=2d95d4be&scoped=true&"
import script from "./CrimeWhen.vue?vue&type=script&lang=ts&"
export * from "./CrimeWhen.vue?vue&type=script&lang=ts&"
import style0 from "./CrimeWhen.vue?vue&type=style&index=0&id=2d95d4be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d95d4be",
  null
  
)

export default component.exports